module.exports = __webpack_public_path__ + "img/cloud-upload-fill.b7cef25c.svg";